(function () {
    'use strict';

    angular
        .module('core.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, PATHS) {
        $stateProvider
            .state('app-auth', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/authentication-layout.html`,
                onEnter: $rootScope => {
                    $rootScope.isOauth = true;
                    $rootScope.hideLoading = true;
                }
            })

            .state('app-auth.login', {
                title: 'Login',
                url: '/login',
                templateUrl: `${PATHS.PHYSICAL}/components/login/login.html`,
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('app-auth.forgot-password', {
                title: 'Esqueci minha senha',
                url: '/forgot-password',
                templateUrl: `${PATHS.PHYSICAL}/components/forgot-password/forgot-password.html`,
                controller: 'ForgotPasswordController',
                controllerAs: 'vm'
            })
            .state('app-auth.reset-password', {
                title: 'Esqueci minha senha',
                url: '/reset-password?t',
                templateUrl: `${PATHS.PHYSICAL}/components/reset-password/reset-password.html`,
                controller: 'ResetPasswordController',
                controllerAs: 'vm'
            })
            .state('app-auth.first-access', {
                title: 'Meu primeiro acesso',
                url: '/first-access',
                templateUrl: `${PATHS.PHYSICAL}/components/first-access/first-access.html`,
                controller: 'FirstAccessController',
                controllerAs: 'vm'
            })
    }
}());